import axios from 'axios'
import { useEffect, useState } from 'react'
import { constants } from '../Constants'
import { AlertDeleteCategories } from '../components/AlertDialogs/AlertDeleteCategories'
import { ModalCreateCategories } from '../components/Modals/ModallCreateCategories'
import { PageLoader } from '../components/ui/Spinner/Spinner'
import { useToast } from '../components/ui/Toast/Toast'
import '../styles/shared.scss'

export const Categories = () => {
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [deleteTarget, setDeleteTarget] = useState(null)
  const toast = useToast()

  const loadCategories = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${constants.urlLocal}categories/getAll`)
      setCategories(response.data.categories || [])
    } catch (error) {
      console.error('Error al cargar las categorías', error)
    }
    setLoading(false)
  }

  useEffect(() => {
    loadCategories()
  }, [])

  const deleteCategory = async id => {
    try {
      const response = await axios.delete(
        `${constants.urlLocal}categories/delete/${id}`
      )
      if (response.data.ok) {
        toast({ title: 'Categoría eliminada', status: 'success' })
        loadCategories()
      }
    } catch (error) {
      toast({ title: 'Error al eliminar', status: 'error' })
    }
    setDeleteTarget(null)
  }

  if (loading)
    return (
      <div className="loading-center">
        <PageLoader />
      </div>
    )

  return (
    <div className="page-container">
      <div className="flex-between" style={{ marginBottom: '1.5rem' }}>
        <h2 className="page-title" style={{ marginBottom: 0 }}>
          Categorías
        </h2>
        <ModalCreateCategories loadCategories={loadCategories} />
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '1rem',
        }}
      >
        {categories.map(cat => (
          <div
            key={cat._id}
            className="card-box"
            style={{ borderLeft: `4px solid ${cat.color}` }}
          >
            <div className="flex-between">
              <h3 style={{ fontWeight: 700 }}>{cat.name}</h3>
              <button
                className="icon-btn icon-btn--danger"
                onClick={() => setDeleteTarget(cat._id)}
                title="Eliminar"
              >
                🗑️
              </button>
            </div>
            <p style={{ color: '#666', fontSize: '0.875rem' }}>
              {cat.description || 'Sin descripción'}
            </p>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                marginTop: '0.5rem',
              }}
            >
              <span
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: '50%',
                  background: cat.color,
                  display: 'inline-block',
                }}
              />
              <span style={{ fontSize: '0.8rem', color: '#999' }}>
                {cat.color}
              </span>
              <span
                style={{
                  fontSize: '0.8rem',
                  marginLeft: 'auto',
                  color: '#666',
                }}
              >
                {cat.isSingleEnrollment ? '1 inscripción' : 'Múltiple'}
              </span>
            </div>
          </div>
        ))}
      </div>
      <AlertDeleteCategories
        isOpen={!!deleteTarget}
        onClose={() => setDeleteTarget(null)}
        onConfirm={() => deleteCategory(deleteTarget)}
      />
    </div>
  )
}
